// import React, { useEffect, useState } from "react"
// import API from '../../services/api';

// import CookieManager from "../../services/CookieManager";
// import { ErrorToast, SuccessToast } from '../../pure-components/CustomToast';
// import { toast } from 'react-toastify';
// import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
// import ExpandLessIcon from '@material-ui/icons/ExpandLess';
// import TableComp from "./tableComp";
// import FilterComp from "./filterComp";
// import InsightImg from "../../assets/insights.png"
// import LicenseInsightImg from "../../assets/license_insights.png"


// const licenseTableHeaderStr="License Number,License Date,Licensee,Project Name,Release Date,Distribution Channel";
// const projectTableHeaderStr="Title,Created By, Created By Email,Track,Track Duration,Created On,Edited On,Description";


// export default function  LicenseInsight(props){

//     const profileData = CookieManager.getCookie("user-data")?.length ? JSON.parse(CookieManager.getCookie("user-data")) : null;
  
//     const [staffUsers, setStaffUsers] = useState([]);

//     const [loadingStaffs, setLoadingStaffs] = useState(false)
//     const [loadingLicenses, setLoadingLicenses] = useState(false);
//     const [licensePageNo, setLicensePageNo] = useState(0);
//     const [licenseFilter, setLicenseFilter] = useState({selectedStaffs : [], dateRange : {startDate : new Date(new Date().setMonth(new Date().getMonth()-6)), endDate : new Date()}})
//     const [licenseList, setLicenseList] = useState([]);
//     const [licenseCount, setLicenseCount] = useState(0);
//     const [licenseTableHeaders, setLicenseTableHeaders] = useState(licenseTableHeaderStr.split(','));
//     const [licenseTableData, setLicenseTableData] = useState([]);
//     const [licenseCSVData, setLicenseCSVData] = useState([]);

//     const [expandedElement, setExpandedElement] = useState('');
    
//     const [projectFilter, setProjectFilter] = useState({selectedStaffs : [], dateRange : {startDate : new Date(new Date().setMonth(new Date().getMonth()-6)), endDate : new Date()}})
//     const [loadingProjects, setLoadingProjects] = useState(false);
//     const [projectList, setProjectList] = useState([]);
//     const [projectCount, setProjectCount] = useState(0);
//     const [projectTableHeaders, setProjectTableHeaders] = useState(projectTableHeaderStr.split(','));
//     const [projectTableData, setProjectTableData] = useState([]);
//     const [projectCSVData, setProjectCSVData] = useState([]);

//     useEffect(() => {
//         (async () => {
//           await fetchCopStaffs();
//         })();
//     }, [])


//     useEffect(() => {
//         if(licenseList?.length > 0){
//             let tempTableData = [];
            
//             //setting License CSV Data
//             let tempCSVData = [];
//             tempCSVData.push(licenseTableHeaderStr.split(','));
            
//             licenseList.forEach(item =>{ 
//                 let licensor=item.licensor ||"";
//                 licensor=licensor.replace(/\n/g," ");
//                 licensor=licensor.replace(/,/g," ");
//                 let lic1=`${item.licenseNumber},${item.createdAt ?new Date(item.createdAt).toDateString():""},${item.licensee ? item.licensee.first_name :""},${item.project? item.project.title.replace(/,/g," ") :""},${item.releaseDate ?new Date(item.releaseDate).toDateString():""},${item.distributionChannel?.replace(/,/g," ")?.replace(/\n/g," ") ||""}`;
//                 tempTableData.push(lic1.split(','))
//                 tempCSVData.push(lic1.split(","));
//             })

//             setLicenseTableData(tempTableData)
//             setLicenseCSVData(tempCSVData)
//         }
//     }, [licenseList])
    
//     const fetchCopStaffs =async()=>{
//         setLoadingStaffs(true);
//         let filter = {userType : "CORPORATE"};
//         filter["admin"] = profileData.email;

//         await API.getUserList({filter:filter}).then(res => {
//             if (res.success){
//                 let tempStaffArr = [];
//                 res.data.map(staff =>{tempStaffArr.push({label : staff.first_name + ' ' + staff.last_name , value : staff._id })})
            
//                 setStaffUsers(tempStaffArr);
//             }
//             else
//             toast(({ closeToast }) => <SuccessToast  message={res.msg}/>);

//             setLoadingStaffs(false);
//         })
//     }
    
//     const handleLicenseFilterStaffSelection = (e) => {
//         setLicenseFilter({...licenseFilter, selectedStaffs : e})
//     } 

//     const setLicenseFilterDates = (e) => {
//         setLicenseFilter({...licenseFilter, dateRange : e})
//     }

//     const loadLicenseData = async() => {
//         //re-setting csv data 
//         setLicenseCSVData([]);

//         let userIds = ["64181898884b6090bc2ff5aa", "6405b9608a3d6f7f1404e08f", "6405b9608a3d6f7f1404e08f"];
//         if(licenseFilter?.selectedStaffs?.length === 0 ){
//             toast(({ closeToast }) => <ErrorToast message={`Please select user(s) and try again.`} />);
//             return;
//         }
        
//         setLoadingLicenses(true);
//         licenseFilter.selectedStaffs.map(staff => {
//             userIds.push(staff.value);
//         })
//         let filter = {licensee : {'$in' : userIds}, "$or" : [
//             {"$and":[{createdAt:{"$gte":licenseFilter.dateRange.startDate}},{createdAt:{"$lte":licenseFilter.dateRange.endDate}} ]},
//             {"$and":[{updatedAt:{"$gte":licenseFilter.dateRange.startDate}},{updatedAt:{"$lte":licenseFilter.dateRange.endDate}} ]}
//         ]}
        
//         await API.getLicenses({query : filter})
//         .then(resp => {
//           if (resp.success) {
//             setLicenseList(resp.data)
//             setLicenseCount(resp.count);
//           }
//           else {
//             toast(({ closeToast }) => <ErrorToast message={`Error : ${resp.status}: ${resp?.statusText}`} />);
//           }
//           setLoadingLicenses(false);
//         }).catch((err) => {
//             setLoadingLicenses(false);
//             toast(({ closeToast }) => <ErrorToast message={`Error : ${err.status}: ${err?.message}`} />);
//         })
        
//     }

//     const handleProjectFilterStaffSelection = (e) => {
//         console.log(e)
//         setProjectFilter({...projectFilter, selectedStaffs : e})
//     } 

//     const setProjectFilterDates = (e) => {
//         setProjectFilter({...projectFilter, dateRange : e})
//     }

//     useEffect(() => {
//         if(projectList?.length > 0){
//             let tempTableData = [];
            
//             //setting License CSV Data
//             let tempCSVData = [];
//             tempCSVData.push(projectTableHeaderStr.split(','));
            
//             projectList.forEach(item =>{ 
//                 let proj1=`${item.title? item.title.replace(/,/g," ") :""},${item.userId? item.userId.first_name.replace(/,/g," ") :""},${item.userId? item.userId.email.replace(/,/g," ") :""}`;
//                 let proj2 = `${item.createdAt ?new Date(item.createdAt).toDateString():""},${item.updatedAt ?new Date(item.updatedAt).toDateString():""},${item.description? item.description.replace(/,/g," ").replace(/\n/g," ") :""}`;
               
//                 let trackDetails=item.trackIds ? item.trackIds :[]
//                 trackDetails.forEach(track=>{
//                     if(track){
//                         let tempRowData = `${proj1},${track.trackId?.title || ""},${track.trackId?.duration ? new Date(parseInt(track.trackId.duration)* 1000).toISOString().substr(14, 5) : ""},${proj2}`;
//                         tempTableData.push(tempRowData.split(','));
//                         tempCSVData.push(tempRowData.split(","));
//                     }
//                 })
//             })

//             setProjectTableData(tempTableData)
//             setProjectCSVData(tempCSVData)
//         }
//     }, [projectList])

//     const loadProjectData = async() => {
//         //re-setting csv data
//         setProjectCSVData([]);

//         let userIds = ["64181898884b6090bc2ff5aa", "6405b9608a3d6f7f1404e08f", "6405b9608a3d6f7f1404e08f"];
//         if(projectFilter.selectedStaffs?.length === 0 ){
//             toast(({ closeToast }) => <ErrorToast message={`Please select user(s) and try again.`} />);
//             return;
//         }
        
//         setLoadingProjects(true);
//         projectFilter.selectedStaffs.map(staff => {
//             userIds.push(staff.value);
//         })
//         let filter = {userId : {'$in' : userIds}, "$or" : [
//             {"$and":[{createdAt:{"$gte":projectFilter.dateRange.startDate}},{createdAt:{"$lte":projectFilter.dateRange.endDate}} ]},
//             {"$and":[{updatedAt:{"$gte":projectFilter.dateRange.startDate}},{updatedAt:{"$lte":projectFilter.dateRange.endDate}} ]}
//         ]}
        
//         await API.loadProjects({query : filter})
//         .then(resp => {
//           if (resp.success) {
//             setProjectList(resp.data)
//             setProjectCount(resp.count);
//           }
//           else {
//             toast(({ closeToast }) => <ErrorToast message={`Error : ${resp.status}: ${resp?.statusText}`} />);
//           }
//           setLoadingProjects(false);
//         }).catch((err) => {
//             setLoadingProjects(false);
//             toast(({ closeToast }) => <ErrorToast message={`Error : ${err.status}: ${err?.message}`} />);
//         })
        
//     }

//     return (
//     <>    
//         <div className="w-full flex mt-20 px-20">
//             <img
//                 className="mr-2"
//                 style={{ height: "36px" }}
//                 alt="Suspended"
//                 src={InsightImg}
//             />
//             <h1 className="text-lg py-2">Insights </h1>
//         </div>
//         <div className='flex flex-wrap p-1 m-1 bg-white lg:mx-20 border border-symStrokeGrey last:border-b-0'>
//             <div className='w-full center-align'>
//                 <div className="w-10/12 flex">
//                     <img
//                         className="mr-2"
//                         style={{ height: "36px" }}
//                         alt="Suspended"
//                         src={LicenseInsightImg}
//                     />
//                     <h1 className="text-lg">License Insights </h1>
//                 </div>
//                 <div className="w-2/12" style={{textAlign : 'right'}}>
//                 {expandedElement === 'LICENSE' ?
//                 <ExpandLessIcon
//                 onClick={() => setExpandedElement('')}
//                 style={{ fontSize: "35px" }}
//                 className="trackicon self-center cursor-pointer text-gray-700"
//                 />
//                 : 
//                 <ExpandMoreIcon
//                 onClick={() => setExpandedElement('LICENSE')}
//                 style={{ fontSize: "35px" }}
//                 className="trackicon self-center cursor-pointer sm:text-gray-700"
//                 />
//                 }
//                 </div>
//             </div>
            
//             {expandedElement === 'LICENSE' &&
//             <>
//                 <FilterComp 
//                 selectedUsers = {licenseFilter.selectedStaffs}
//                 users = {staffUsers}
//                 handleUserSelection = {handleLicenseFilterStaffSelection}
//                 startDate = {licenseFilter.dateRange.startDate}
//                 endDate = {licenseFilter.dateRange.endDate}
//                 setDateRangeValues = {setLicenseFilterDates}
//                 loadData = {loadLicenseData}
//                 buttonTitle = {"View Licenses"}
//                 csvData = {licenseCSVData}
//                 />

//                 <div className="w-full center-align" >
//                     {loadingLicenses ? 
//                     <label className="w-full " style={{"textAlign": "center", "color": "green"}}>Loading Licenses... Please Wait...</label> 
//                     :
//                     licenseList?.length > 0 ? 
//                     <TableComp 
//                     totalCount = {licenseCount}
//                     headers = {licenseTableHeaders}
//                     data = {licenseTableData}
//                     pageNo = {licensePageNo}
//                     setPageNo = {setLicensePageNo}
//                     loadData = {loadLicenseData}
//                     />
//                     :
//                     <label className="w-full " style={{"textAlign": "center", "color": "red"}}>No Records Found, Select Filter and Try Again!!!</label> 
//                     }
//                 </div>
//             </>
//             }  
//         </div>
//         <div className='flex flex-wrap p-1 bg-white lg:mx-20 border border-symStrokeGrey last:border-b-0'>
//             <div className='w-full center-align'>
//                 <div className="w-10/12 flex">
//                     <img
//                         className="mr-2"
//                         style={{ height: "36px" }}
//                         alt="Suspended"
//                         src={LicenseInsightImg}
//                     />
//                     <h1 className="text-lg">Project Insights </h1>
//                 </div>
//                 <div className="w-2/12" style={{textAlign : 'right'}}>
//                 {expandedElement === 'PROJECT' ?
//                 <ExpandLessIcon
//                 onClick={() => setExpandedElement('')}
//                 style={{ fontSize: "35px" }}
//                 className="trackicon self-center cursor-pointer text-gray-700"
//                 />
//                 : 
//                 <ExpandMoreIcon
//                 onClick={() => setExpandedElement('PROJECT')}
//                 style={{ fontSize: "35px" }}
//                 className="trackicon self-center cursor-pointer sm:text-gray-700"
//                 />
//                 }
//                 </div>
//             </div>
            
//             {expandedElement === 'PROJECT' &&
//             <>
//                 <FilterComp 
//                 selectedUsers = {projectFilter.selectedStaffs}
//                 users = {staffUsers}
//                 handleUserSelection = {handleProjectFilterStaffSelection}
//                 startDate = {projectFilter.dateRange.startDate}
//                 endDate = {projectFilter.dateRange.endDate}
//                 setDateRangeValues = {setProjectFilterDates}
//                 loadData = {loadProjectData}
//                 buttonTitle = {"View Projects"}
//                 csvData = {projectCSVData}
//                 />
//                 <div className="w-full center-align" >
//                     {loadingProjects ? 
//                     <label className="w-full " style={{"textAlign": "center", "color": "green"}}>Loading Projects Data... Please Wait...</label> 
//                     :
//                     projectList?.length > 0 ? 
//                     <TableComp 
//                     totalCount = {projectCount}
//                     headers = {projectTableHeaders}
//                     data = {projectTableData}
//                     loadData = {loadProjectData}
//                     />
//                     :
//                     <label className="w-full " style={{"textAlign": "center", "color": "red"}}>No Records Found, Select Filter and Try Again!!!</label> 
//                     }
//                 </div>
//             </>
//             }  
//         </div>

//     </>)

// }


import React, { useEffect, useState } from "react";
import API from '../../services/api';
import CookieManager from "../../services/CookieManager";
import { ErrorToast, SuccessToast } from '../../pure-components/CustomToast';
import { toast } from 'react-toastify';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import TableComp from "./tableComp";
import FilterComp from "./filterComp";
import InsightImg from "../../assets/insights.png";
import LicenseInsightImg from "../../assets/license_insights.png";

const licenseTableHeaderStr = "License Name,License Number,License Date,Licensee,Project Name,Project Duration,Music Duration,Release Date,Distribution Channel,Track Details,Download";
const projectTableHeaderStr = "Title,Created By,Created By Email,Track,Created On,Edited On,Description,Track Details";

export default function LicenseInsight(props) {
    const profileData = CookieManager.getCookie("user-data")?.length ? JSON.parse(CookieManager.getCookie("user-data")) : null;

    const [staffUsers, setStaffUsers] = useState([]);
    const [loadingStaffs, setLoadingStaffs] = useState(false);
    const [loadingLicenses, setLoadingLicenses] = useState(false);
    const [licensePageNo, setLicensePageNo] = useState(0);
    const [licenseFilter, setLicenseFilter] = useState({ selectedStaffs: [], dateRange: { startDate: null, endDate: null } });
    const [licenseList, setLicenseList] = useState([]);
    const [licenseCount, setLicenseCount] = useState(0);
    const [licenseTableHeaders, setLicenseTableHeaders] = useState(licenseTableHeaderStr.split(','));
    const [licenseTableData, setLicenseTableData] = useState([]);
    const [licenseCSVData, setLicenseCSVData] = useState([]);
    const [expandedElement, setExpandedElement] = useState('');
    const [projectFilter, setProjectFilter] = useState({ selectedStaffs: [], dateRange: { startDate: null, endDate: null } });
    const [loadingProjects, setLoadingProjects] = useState(false);
    const [projectList, setProjectList] = useState([]);
    const [projectCount, setProjectCount] = useState(0);
    const [projectTableHeaders, setProjectTableHeaders] = useState(projectTableHeaderStr.split(','));
    const [projectTableData, setProjectTableData] = useState([]);
    const [projectCSVData, setProjectCSVData] = useState([]);

    // Helper function to format seconds to MM:SS
    const formatDuration = (seconds) => {
        if (!seconds && seconds !== 0) return "";
        const minutes = Math.floor(seconds / 60);
        const remainingSeconds = seconds % 60;
        return `${minutes}:${remainingSeconds.toString().padStart(2, '0')}`;
    };

    // Helper function to parse distributionChannel
    const parseDistributionChannel = (channelData) => {
        if (!channelData) return null;
        if (typeof channelData === 'object') return channelData;
        if (typeof channelData === 'string') {
            try {
                return JSON.parse(channelData);
            } catch (e) {
                console.error(`Failed to parse distributionChannel: ${channelData}`, e);
                return null;
            }
        }
        return null;
    };

    // Process licenseList to parse distributionChannel when API data is loaded
    const processLicenseList = (data) => {
        return data.map(item => ({
            ...item,
            distributionChannel: parseDistributionChannel(item.distributionChannel)
        }));
    };

    useEffect(() => {
        (async () => {
            const staffs = await fetchCopStaffs();
            const initLicenseFilter = { selectedStaffs: staffs, dateRange: { startDate: null, endDate: null } };
            const initProjectFilter = { selectedStaffs: staffs, dateRange: { startDate: null, endDate: null } };
            setLicenseFilter(initLicenseFilter);
            setProjectFilter(initProjectFilter);
            setExpandedElement('LICENSE');
            await loadLicenseData(initLicenseFilter);
            setExpandedElement('PROJECT');
            await loadProjectData(initProjectFilter);
        })();
    }, []);

    useEffect(() => {
        if (licenseList?.length > 0) {
            let tempTableData = [];
            let tempCSVData = [];
            tempCSVData.push(licenseTableHeaderStr.split(','));

            licenseList.forEach(item => {
                try {
                    let licensor = item.licensor || "";
                    licensor = licensor.split(',')[0].trim();
                    licensor = licensor.replace(/\n/g, " ").replace(/,/g, " ");
                    const distributionChannelValue = item.distributionChannel && typeof item.distributionChannel === 'object' && Object.keys(item.distributionChannel).length > 0 ? "View" : "-";
                    let lic1 = `${licensor},${item.licenseNumber},${item.createdAt ? new Date(item.createdAt).toDateString() : ""},${item.licensee ? item.licensee.first_name : ""},${item.project ? item.project.title.replace(/,/g, " ") : ""},${formatDuration(item.totalDuration)},${formatDuration(item.musicDuration)},${item.releaseDate ? new Date(item.releaseDate).toDateString() : ""},${distributionChannelValue},View,${item.licenseUrl}`;
                    tempTableData.push(lic1.split(','));
                    tempCSVData.push(lic1.split(","));
                } catch (error) {
                    console.error(`Error processing license item:`, item, error);
                }
            });

            setLicenseTableData(tempTableData);
            setLicenseCSVData(tempCSVData);
        } else {
            setLicenseTableData([]);
            setLicenseCSVData([]);
        }
    }, [licenseList]);

    useEffect(() => {
        if (projectList?.length > 0) {
            let tempTableData = [];
            let tempCSVData = [];
            tempCSVData.push(projectTableHeaderStr.split(','));

            projectList.forEach(item => {
                try {
                    let proj1 = `${item.title ? item.title.replace(/,/g, " ") : ""},${item.userId ? item.userId.first_name.replace(/,/g, " ") : ""},${item.userId ? item.userId.email.replace(/,/g, " ") : ""}`;
                    let proj2 = `${item.createdAt ? new Date(item.createdAt).toDateString() : ""},${item.updatedAt ? new Date(item.updatedAt).toDateString() : ""}`;
                    let trackCount = item.trackIds ? item.trackIds.length : 0;
                    let description = item.description || '-';
                    let tempRowData = `${proj1},${trackCount},${proj2},${description},View`;
                    tempTableData.push(tempRowData.split(','));
                    tempCSVData.push(tempRowData.split(","));
                } catch (error) {
                    console.error(`Error processing project item:`, item, error);
                }
            });

            setProjectTableData(tempTableData);
            setProjectCSVData(tempCSVData);
        } else {
            setProjectTableData([]);
            setProjectCSVData([]);
        }
    }, [projectList]);

    const fetchCopStaffs = async () => {
        setLoadingStaffs(true);
        let filter = { userType: "CORPORATE" };
        filter["admin"] = profileData.email;

        try {
            const res = await API.getUserList({ filter: filter });
            setLoadingStaffs(false);
            if (res.success) {
                let tempStaffArr = [];
                res.data.map(staff => {
                    tempStaffArr.push({ label: staff.first_name + ' ' + staff.last_name, value: staff._id });
                });
                setStaffUsers(tempStaffArr);
                return tempStaffArr;
            } else {
                toast(({ closeToast }) => <SuccessToast message={res.msg} />);
            }
        } catch (error) {
            setLoadingStaffs(false);
            toast(({ closeToast }) => <ErrorToast message={`Error fetching staff users: ${error.message}`} />);
        }
        return [];
    };

    const handleLicenseFilterStaffSelection = (e) => {
        setLicenseFilter({ ...licenseFilter, selectedStaffs: e });
    };

    const setLicenseFilterDates = (e) => {
        setLicenseFilter({ ...licenseFilter, dateRange: e });
    };

    const clearLicenseFilter = () => {
        const clearedFilter = { selectedStaffs: staffUsers, dateRange: { startDate: null, endDate: null } };
        setLicenseFilter(clearedFilter);
        loadLicenseData(clearedFilter);
    };

    const loadLicenseData = async (customFilter = null) => {
        let usedFilter = customFilter || { ...licenseFilter };
        setLicenseCSVData([]);

        if (!usedFilter?.selectedStaffs || usedFilter?.selectedStaffs?.length === 0) {
            toast(({ closeToast }) => <ErrorToast message={`Please select at least one user to view license data.`} />);
            return;
        }

        setLoadingLicenses(true);
        let userIds = [];
        usedFilter.selectedStaffs.map(staff => {
            userIds.push(staff.value);
        });
        let filter = { licensee: { '$in': userIds } };
        if (usedFilter.dateRange.startDate && usedFilter.dateRange.endDate) {
            filter["$or"] = [
                { "$and": [{ createdAt: { "$gte": usedFilter.dateRange.startDate } }, { createdAt: { "$lte": usedFilter.dateRange.endDate } }] },
                { "$and": [{ updatedAt: { "$gte": usedFilter.dateRange.startDate } }, { updatedAt: { "$lte": usedFilter.dateRange.endDate } }] }
            ];
        }

        try {
            const resp = await API.getLicenses({ query: filter });
            if (resp.success) {
                setLicenseList(processLicenseList(resp.data));
                setLicenseCount(resp.count);
            } else {
                toast(({ closeToast }) => <ErrorToast message={`Error: ${resp.status}: ${resp?.statusText}`} />);
            }
        } catch (err) {
            toast(({ closeToast }) => <ErrorToast message={`Error: ${err.status}: ${err?.message}`} />);
        } finally {
            setLoadingLicenses(false);
        }
    };

    const handleProjectFilterStaffSelection = (e) => {
        setProjectFilter({ ...projectFilter, selectedStaffs: e });
    };

    const setProjectFilterDates = (e) => {
        setProjectFilter({ ...projectFilter, dateRange: e });
    };

    const clearProjectFilter = () => {
        const clearedFilter = { selectedStaffs: staffUsers, dateRange: { startDate: null, endDate: null } };
        setProjectFilter(clearedFilter);
        loadProjectData(clearedFilter);
    };

    const loadProjectData = async (customFilter = null) => {
        let usedFilter = customFilter || { ...projectFilter };
        setProjectCSVData([]);

        if (!usedFilter?.selectedStaffs || usedFilter.selectedStaffs?.length === 0) {
            toast(({ closeToast }) => <ErrorToast message={`Please select at least one user to view project data.`} />);
            return;
        }

        setLoadingProjects(true);
        let userIds = [];
        usedFilter.selectedStaffs.map(staff => {
            userIds.push(staff.value);
        });
        let filter = { userId: { '$in': userIds } };
        if (usedFilter.dateRange.startDate && usedFilter.dateRange.endDate) {
            filter["$or"] = [
                { "$and": [{ createdAt: { "$gte": usedFilter.dateRange.startDate } }, { createdAt: { "$lte": usedFilter.dateRange.endDate } }] },
                { "$and": [{ updatedAt: { "$gte": usedFilter.dateRange.startDate } }, { updatedAt: { "$lte": usedFilter.dateRange.endDate } }] }
            ];
        }

        try {
            const resp = await API.loadProjects({ query: filter });
            if (resp.success) {
                setProjectList(resp.data);
                setProjectCount(resp.count);
            } else {
                toast(({ closeToast }) => <ErrorToast message={`Error: ${resp.status}: ${resp?.statusText}`} />);
            }
        } catch (err) {
            toast(({ closeToast }) => <ErrorToast message={`Error: ${err.status}: ${err?.message}`} />);
        } finally {
            setLoadingProjects(false);
        }
    };

    return (
        <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100">
            <div className="max-w-7xl mx-auto px-3 sm:px-4 lg:px-8 py-4 sm:py-6 lg:py-8 space-y-4 sm:space-y-6 lg:space-y-8">
                <div className="bg-white rounded-lg lg:rounded-xl shadow-lg border border-gray-200 overflow-hidden transition-all duration-300 hover:shadow-xl">
                    <div
                        className="flex flex-col sm:flex-row sm:items-center justify-between p-3 sm:p-4 lg:p-6 bg-gradient-to-r from-blue-50 to-indigo-50 border-b border-gray-200 cursor-pointer hover:from-blue-100 hover:to-indigo-100 transition-colors duration-200 space-y-2 sm:space-y-0"
                        onClick={() => setExpandedElement(expandedElement === 'LICENSE' ? '' : 'LICENSE')}
                    >
                        <div className="flex items-center space-x-2 sm:space-x-3 lg:space-x-4">
                            <div className="flex items-center justify-center w-6 h-6 sm:w-8 sm:h-8 lg:w-10 lg:h-10 bg-blue-100 rounded-lg flex-shrink-0">
                                <img
                                    className="w-3 h-3 sm:w-4 sm:h-4 lg:w-5 lg:h-5"
                                    alt="License Insights"
                                    src={LicenseInsightImg}
                                />
                            </div>
                            <div>
                                <h2 className="text-base sm:text-lg lg:text-xl font-semibold text-gray-900">License Insights</h2>
                                <p className="text-xs sm:text-sm text-gray-600 hidden sm:block">Track and analyze license data</p>
                            </div>
                        </div>
                        <div className="flex items-center justify-between sm:justify-end space-x-2 w-full sm:w-auto">
                            {licenseCount > 0 && (
                                <span className="px-2 py-1 sm:px-3 sm:py-1 bg-blue-100 text-blue-800 text-xs sm:text-sm font-medium rounded-full">
                                    {licenseCount} Licenses
                                </span>
                            )}
                            <div className="p-1 rounded-full hover:bg-white/50 transition-colors duration-200 ml-auto sm:ml-0">
                                {expandedElement === 'LICENSE' ?
                                    <ExpandLessIcon style={{ fontSize: "20px" }} className="text-gray-600 sm:text-2xl" />
                                    : <ExpandMoreIcon style={{ fontSize: "20px" }} className="text-gray-600 sm:text-2xl" />
                                }
                            </div>
                        </div>
                    </div>
                    {expandedElement === 'LICENSE' && (
                        <div className="p-3 sm:p-4 lg:p-6 space-y-3 sm:space-y-4 lg:space-y-6 animate-fadeIn">
                            <div className="bg-gray-50 rounded-lg p-3 sm:p-4">
                                <FilterComp
                                    selectedUsers={licenseFilter.selectedStaffs}
                                    users={staffUsers}
                                    handleUserSelection={handleLicenseFilterStaffSelection}
                                    startDate={licenseFilter.dateRange.startDate}
                                    endDate={licenseFilter.dateRange.endDate}
                                    setDateRangeValues={setLicenseFilterDates}
                                    loadData={loadLicenseData}
                                    buttonTitle={"View Licenses"}
                                    csvData={licenseCSVData}
                                    clearFilter={clearLicenseFilter}
                                />
                            </div>
                            <div className="min-h-[200px] sm:min-h-[250px] lg:min-h-[300px]">
                                {loadingLicenses ? (
                                    <div className="flex flex-col items-center justify-center py-8 sm:py-12 lg:py-16 space-y-3 sm:space-y-4">
                                        <div className="w-5 h-5 sm:w-6 sm:h-6 lg:w-8 lg:h-8 border-3 sm:border-4 border-blue-200 border-t-blue-600 rounded-full animate-spin"></div>
                                        <p className="text-sm sm:text-base lg:text-lg font-medium text-blue-600">Loading Licenses...</p>
                                        <p className="text-xs sm:text-sm text-gray-500 text-center px-4">Please wait while we fetch your data</p>
                                    </div>
                                ) : licenseList?.length > 0 ? (
                                    <div className="bg-gray-50 rounded-lg p-2 sm:p-3 lg:p-4 overflow-x-auto">
                                        <TableComp
                                            totalCount={licenseCount}
                                            headers={licenseTableHeaders}
                                            data={licenseTableData}
                                            pageNo={licensePageNo}
                                            setPageNo={setLicensePageNo}
                                            loadData={loadLicenseData}
                                            trackDetailsData={licenseList}
                                            channelDetailsData={licenseList}
                                        />
                                    </div>
                                ) : (
                                    <div className="text-center py-8 sm:py-12 lg:py-16 px-4">
                                        <div className="w-10 h-10 sm:w-12 sm:h-12 lg:w-16 lg:h-16 mx-auto mb-3 sm:mb-4 bg-gray-100 rounded-full flex items-center justify-center">
                                            <svg className="w-5 h-5 sm:w-6 sm:h-6 lg:w-8 lg:h-8 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                                            </svg>
                                        </div>
                                        <h3 className="text-sm sm:text-base lg:text-lg font-medium text-gray-900 mb-1 sm:mb-2">No Records Found</h3>
                                        <p className="text-xs sm:text-sm text-gray-500">Select filters and try again to view license data</p>
                                    </div>
                                )}
                            </div>
                        </div>
                    )}
                </div>
                <div className="bg-white rounded-lg lg:rounded-xl shadow-lg border border-gray-200 overflow-hidden transition-all duration-300 hover:shadow-xl">
                    <div
                        className="flex flex-col sm:flex-row sm:items-center justify-between p-3 sm:p-4 lg:p-6 bg-gradient-to-r from-green-50 to-emerald-50 border-b border-gray-200 cursor-pointer hover:from-green-100 hover:to-emerald-100 transition-colors duration-200 space-y-2 sm:space-y-0"
                        onClick={() => setExpandedElement(expandedElement === 'PROJECT' ? '' : 'PROJECT')}
                    >
                        <div className="flex items-center space-x-2 sm:space-x-3 lg:space-x-4">
                            <div className="flex items-center justify-center w-6 h-6 sm:w-8 sm:h-8 lg:w-10 lg:h-10 bg-green-100 rounded-lg flex-shrink-0">
                                <img
                                    className="w-3 h-3 sm:w-4 sm:h-4 lg:w-5 lg:h-5"
                                    alt="Project Insights"
                                    src={LicenseInsightImg}
                                />
                            </div>
                            <div>
                                <h2 className="text-base sm:text-lg lg:text-xl font-semibold text-gray-900">Project Insights</h2>
                                <p className="text-xs sm:text-sm text-gray-600 hidden sm:block">Monitor project performance and metrics</p>
                            </div>
                        </div>
                        <div className="flex items-center justify-between sm:justify-end space-x-2 w-full sm:w-auto">
                            {projectCount > 0 && (
                                <span className="px-2 py-1 sm:px-3 sm:py-1 bg-green-100 text-green-800 text-xs sm:text-sm font-medium rounded-full">
                                    {projectCount} Projects
                                </span>
                            )}
                            <div className="p-1 rounded-full hover:bg-white/50 transition-colors duration-200 ml-auto sm:ml-0">
                                {expandedElement === 'PROJECT' ?
                                    <ExpandLessIcon style={{ fontSize: "20px" }} className="text-gray-600 sm:text-2xl" />
                                    : <ExpandMoreIcon style={{ fontSize: "20px" }} className="text-gray-600 sm:text-2xl" />
                                }
                            </div>
                        </div>
                    </div>
                    {expandedElement === 'PROJECT' && (
                        <div className="p-3 sm:p-4 lg:p-6 space-y-3 sm:space-y-4 lg:space-y-6 animate-fadeIn">
                            <div className="bg-gray-50 rounded-lg p-3 sm:p-4">
                                <FilterComp
                                    selectedUsers={projectFilter.selectedStaffs}
                                    users={staffUsers}
                                    handleUserSelection={handleProjectFilterStaffSelection}
                                    startDate={projectFilter.dateRange.startDate}
                                    endDate={projectFilter.dateRange.endDate}
                                    setDateRangeValues={setProjectFilterDates}
                                    loadData={loadProjectData}
                                    buttonTitle={"View Projects"}
                                    csvData={projectCSVData}
                                    clearFilter={clearProjectFilter}
                                />
                            </div>
                            <div className="min-h-[200px] sm:min-h-[250px] lg:min-h-[300px]">
                                {loadingProjects ? (
                                    <div className="flex flex-col items-center justify-center py-8 sm:py-12 lg:py-16 space-y-3 sm:space-y-4">
                                        <div className="w-5 h-5 sm:w-6 sm:h-6 lg:w-8 lg:h-8 border-3 sm:border-4 border-green-200 border-t-green-600 rounded-full animate-spin"></div>
                                        <p className="text-sm sm:text-base lg:text-lg font-medium text-green-600">Loading Projects...</p>
                                        <p className="text-xs sm:text-sm text-gray-500 text-center px-4">Please wait while we fetch your data</p>
                                    </div>
                                ) : projectList?.length > 0 ? (
                                    <div className="bg-gray-50 rounded-lg p-2 sm:p-3 lg:p-4 overflow-x-auto">
                                        <TableComp
                                            totalCount={projectCount}
                                            headers={projectTableHeaders}
                                            data={projectTableData}
                                            loadData={loadProjectData}
                                            trackDetailsData={projectList}
                                            channelDetailsData={projectList}
                                        />
                                    </div>
                                ) : (
                                    <div className="text-center py-8 sm:py-12 lg:py-16 px-4">
                                        <div className="w-10 h-10 sm:w-12 sm:h-12 lg:w-16 lg:h-16 mx-auto mb-3 sm:mb-4 bg-gray-100 rounded-full flex items-center justify-center">
                                            <svg className="w-5 h-5 sm:w-6 sm:h-6 lg:w-8 lg:h-8 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012 2v2M7 7h10" />
                                            </svg>
                                        </div>
                                        <h3 className="text-sm sm:text-base lg:text-lg font-medium text-gray-900 mb-1 sm:mb-2">No Records Found</h3>
                                        <p className="text-xs sm:text-sm text-gray-500">Select filters and try again to view project data</p>
                                    </div>
                                )}
                            </div>
                        </div>
                    )}
                </div>
            </div>
            <style jsx>{`
                @keyframes fadeIn {
                    from {
                        opacity: 0;
                        transform: translateY(-10px);
                    }
                    to {
                        opacity: 1;
                        transform: translateY(0);
                    }
                }
                .animate-fadeIn {
                    animation: fadeIn 0.3s ease-out;
                }
            `}</style>
        </div>
    );
}